$R.addLang('fr', {
    'video': 'Vidéo',
    'video-html-code': 'Code intégration de vidéo ou lien Youtube/Vimeo'
});